(function () {
  function initAnnouncement(root) {
    if (!root || root.dataset.ffInit) return;
    var items = Array.prototype.slice.call(root.querySelectorAll('[data-ff-announce-item]'));
    if (items.length < 2) return;
    root.dataset.ffInit = '1';
    var index = 0;
    var paused = false;
    var timer = null;

    function show(i) {
      items.forEach(function (el, n) {
        el.hidden = n !== i;
        el.setAttribute('aria-hidden', n !== i ? 'true' : 'false');
      });
      index = i;
    }

    function next() {
      if (paused) return;
      show((index + 1) % items.length);
    }

    function start() {
      clearInterval(timer);
      timer = setInterval(next, 10000);
    }

    root.addEventListener('mouseenter', function () { paused = true; });
    root.addEventListener('mouseleave', function () { paused = false; });
    root.addEventListener('focusin', function () { paused = true; });
    root.addEventListener('focusout', function () { paused = false; });

    show(0);
    start();
  }

  function initHero(root) {
    if (!root || root.dataset.ffInit) return;
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-ff-hero-slide]'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-ff-hero-dot]'));
    if (slides.length < 2) return;
    root.dataset.ffInit = '1';
    var index = 0;
    var paused = false;
    var timer = null;

    function show(i) {
      slides.forEach(function (el, n) {
        el.classList.toggle('is-active', n === i);
        el.setAttribute('aria-hidden', n === i ? 'false' : 'true');
      });
      dots.forEach(function (el, n) {
        el.classList.toggle('is-active', n === i);
        el.setAttribute('aria-current', n === i ? 'true' : 'false');
      });
      index = i;
    }

    function next() {
      if (paused) return;
      show((index + 1) % slides.length);
    }

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        show(i);
        clearInterval(timer);
        timer = setInterval(next, 10000);
      });
    });

    root.addEventListener('mouseenter', function () { paused = true; });
    root.addEventListener('mouseleave', function () { paused = false; });

    show(0);
    timer = setInterval(next, 10000);
  }

  function initFaq(root) {
    if (!root || root.dataset.ffInit) return;
    root.dataset.ffInit = '1';
    var buttons = Array.prototype.slice.call(root.querySelectorAll('[data-ff-faq-btn]'));
    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var expanded = btn.getAttribute('aria-expanded') === 'true';
        var panelId = btn.getAttribute('aria-controls');
        var panel = panelId ? document.getElementById(panelId) : null;
        buttons.forEach(function (other) {
          other.setAttribute('aria-expanded', 'false');
          var otherPanel = document.getElementById(other.getAttribute('aria-controls'));
          if (otherPanel) otherPanel.hidden = true;
        });
        if (!expanded && panel) {
          btn.setAttribute('aria-expanded', 'true');
          panel.hidden = false;
        }
      });
    });
  }

  function initFooterAccordions(root) {
    if (!root || root.dataset.ffInit) return;
    root.dataset.ffInit = '1';
    var toggles = Array.prototype.slice.call(root.querySelectorAll('[data-ff-footer-toggle]'));
    toggles.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var expanded = btn.getAttribute('aria-expanded') === 'true';
        var panel = document.getElementById(btn.getAttribute('aria-controls'));
        var next = !expanded;
        btn.setAttribute('aria-expanded', next ? 'true' : 'false');
        if (panel) panel.classList.toggle('is-open', next);
      });
    });
  }

  function initReviews(root) {
    if (!root || root.dataset.ffInit) return;
    root.dataset.ffInit = '1';
    var bars = Array.prototype.slice.call(root.querySelectorAll('[data-ff-review-filter]'));
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-ff-review-card]'));
    var track = root.querySelector('[data-ff-reviews-track]');
    var prev = root.querySelector('[data-ff-reviews-prev]');
    var next = root.querySelector('[data-ff-reviews-next]');
    var active = null;

    function visibleCards() {
      return cards.filter(function (card) { return !card.hidden; });
    }

    function apply(rating) {
      cards.forEach(function (card) {
        var match = !rating || String(card.getAttribute('data-rating')) === String(rating);
        card.hidden = !match;
      });
      bars.forEach(function (bar) {
        var on = rating && String(bar.getAttribute('data-ff-review-filter')) === String(rating);
        bar.classList.toggle('is-active', !!on);
        bar.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      if (track) track.scrollLeft = 0;
    }

    bars.forEach(function (bar) {
      bar.addEventListener('click', function () {
        var rating = bar.getAttribute('data-ff-review-filter');
        if (active === rating) {
          active = null;
          apply(null);
        } else {
          active = rating;
          apply(rating);
        }
      });
    });

    function scrollByCard(dir) {
      if (!track) return;
      var list = visibleCards();
      var card = list[0] || track.querySelector('.ff-reviews__card');
      var amount = card ? card.getBoundingClientRect().width + 16 : track.clientWidth * 0.8;
      track.scrollBy({ left: dir * amount, behavior: 'smooth' });
    }

    if (prev) prev.addEventListener('click', function () { scrollByCard(-1); });
    if (next) next.addEventListener('click', function () { scrollByCard(1); });
  }

  function initCelebs(root) {
    if (!root || root.dataset.ffInit) return;
    var track = root.querySelector('[data-ff-celebs-track]');
    var prev = root.querySelector('[data-ff-celebs-prev]');
    var next = root.querySelector('[data-ff-celebs-next]');
    if (!track) return;
    root.dataset.ffInit = '1';

    function scrollByCard(dir) {
      var card = track.querySelector('.ff-celebs__card');
      var amount = card ? card.getBoundingClientRect().width + 16 : track.clientWidth * 0.7;
      track.scrollBy({ left: dir * amount, behavior: 'smooth' });
    }

    if (prev) prev.addEventListener('click', function () { scrollByCard(-1); });
    if (next) next.addEventListener('click', function () { scrollByCard(1); });
  }

  function initCatSwitcher(root) {
    if (!root || root.dataset.ffCatInit) return;
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-ff-cat-tab]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-ff-cat-panel]'));
    if (!tabs.length || !panels.length) return;
    root.dataset.ffCatInit = '1';

    function activate(index) {
      tabs.forEach(function (tab, i) {
        var on = i === index;
        tab.classList.toggle('is-active', on);
        tab.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      panels.forEach(function (panel, i) {
        var on = i === index;
        panel.hidden = !on;
        if (on) {
          var track = panel.querySelector('[data-ff-cat-track]');
          if (track) track.scrollLeft = 0;
        }
      });
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        activate(Number(tab.getAttribute('data-ff-cat-tab')) || 0);
      });
    });
  }

  function boot() {
    document.querySelectorAll('[data-ff-announce]').forEach(initAnnouncement);
    document.querySelectorAll('[data-ff-hero]').forEach(initHero);
    document.querySelectorAll('[data-ff-faq]').forEach(initFaq);
    document.querySelectorAll('[data-ff-footer]').forEach(initFooterAccordions);
    document.querySelectorAll('[data-ff-reviews]').forEach(initReviews);
    document.querySelectorAll('[data-ff-celebs]').forEach(initCelebs);
    document.querySelectorAll('[data-ff-cat-switcher]').forEach(initCatSwitcher);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
